import SearchHistoryContent from './SearchHistoryContent';

export default SearchHistoryContent;
